
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Kothrudtomumbaicab() {



    const cardData =
    {
        keyword: 'Kothrud to Mumbai Cab  ',
        heading: 'Vedant Travels: Kothrud to Mumbai Cab ',
        headingDescription: 'Vedant Travels offers affordable and transparent taxi fares for Kothrud to Mumbai travel, ensuring a cost-effective and comfortable journey. Our pricing is competitive, with no hidden charges, and we provide multiple cab options to suit your budget and preferences.',

        top: 'Top Places to Visit in Mumbai with Vedant Travels',

"topPlaces": [
        {
            "title": "Gateway of India",
            "description": "One of Mumbai’s most iconic landmarks, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this magnificent structure is a favorite among tourists for sightseeing and photography. You can also take a ferry from here to visit Elephanta Caves."
        },
        {
            "title": "Marine Drive",
            "description": "Also known as the Queen’s Necklace, Marine Drive is a 3.6 km-long boulevard along the coastline of Mumbai. It’s the perfect spot for an evening stroll, enjoying the sea breeze, or watching the sunset. At night, the streetlights form a stunning arc that resembles a necklace, making it one of the most picturesque locations in Mumbai."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are located on Elephanta Island and feature ancient rock-cut temples dedicated to Lord Shiva. The caves date back to the 5th–7th centuries and are known for their intricate sculptures and carvings. A ferry ride from the Gateway of India takes you to this historical site, offering a blend of nature, history, and spirituality."
        },
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A masterpiece of Victorian Gothic architecture, CSMT is not just a railway station but a UNESCO-listed historic site. The station, formerly known as Victoria Terminus, features grand turrets, stained glass windows, and intricate stone carvings, showcasing the colonial-era grandeur of Mumbai."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of the most revered Hindu temples in Mumbai, Siddhivinayak Temple is dedicated to Lord Ganesha. Thousands of devotees visit the temple daily to seek blessings, including Bollywood celebrities and politicians. The temple’s beautiful architecture and spiritual ambiance make it a must-visit."
        },
        {
            "title": "Juhu Beach",
            "description": "Juhu Beach is among the most famous beaches in Mumbai, known for its lively atmosphere and delicious street food. Whether you want to relax by the sea, take a camel ride, or try local delicacies like pav bhaji, vada pav, and bhel puri, this beach has something for everyone. It's also a popular spot for catching a mesmerizing sunset."
        },
        {
            "title": "Colaba Causeway",
            "description": "If you love shopping, Colaba Causeway is the place to be. This bustling street market is filled with stalls selling jewelry, handicrafts, clothes, antiques, and souvenirs. Besides shopping, you can also explore the charming cafés and restaurants in the area, such as Leopold Café, a historic eatery loved by tourists."
        },
        {
            "title": "Haji Ali Dargah",
            "description": "Situated on a small islet off the coast of Worli, Haji Ali Dargah is a significant religious and architectural landmark in Mumbai. This Indo-Islamic shrine is dedicated to the Sufi saint Haji Ali and is accessible via a narrow causeway that gets submerged during high tide. The dargah’s serene atmosphere and breathtaking views make it a must-visit destination."
        },
        {
            "title": "Bandra-Worli Sea Link",
            "description": "An architectural marvel, the Bandra-Worli Sea Link is an eight-lane bridge that connects South Mumbai to the suburbs. The cable-stayed bridge offers spectacular views of the Arabian Sea and Mumbai’s skyline, especially when illuminated at night. It significantly reduces travel time between Bandra and Worli, making it a vital part of Mumbai’s infrastructure."
        },
        {
            "title": "Bollywood Film City",
            "description": "Mumbai is the heart of the Indian film industry, and Film City in Goregaon offers visitors a chance to witness Bollywood magic up close. With multiple studios, sets, and backdrops, Film City is where countless Bollywood movies and TV shows are filmed. Guided tours provide an exclusive behind-the-scenes look at Mumbai’s thriving cinema industry, making it a must-visit for movie buffs."
        }
    ],


"services": [
    {
        "name": "Kothrud to Mumbai Airport Cab",
        "description": "Book a comfortable and reliable taxi from Kothrud to Mumbai Airport with Vedant Travels. We ensure timely arrivals with professional drivers and a smooth ride."
    },
    {
        "name": "Kothrud to Mumbai International Airport Cab",
        "description": "Traveling to Mumbai International Airport from Kothrud? Vedant Travels offers affordable and efficient services to make your journey easy and comfortable."
    },
    {
        "name": "Kothrud to Mumbai One Way Cab",
        "description": "For a one-way trip from Kothrud to Mumbai, choose Vedant Travels. We offer affordable, flexible, and reliable one-way taxi services for your convenience."
    },
    {
        "name": "Kothrud to Mumbai Drop Taxi",
        "description": "Need a taxi for a Mumbai drop from Kothrud? We provide prompt drop services to Mumbai, ensuring you reach your destination safely and on time."
    },
    {
        "name": "Kothrud to Dadar Taxi Service",
        "description": "Book a reliable and affordable taxi service from Kothrud to Dadar with Vedant Travels. Enjoy a comfortable ride at competitive prices."
    },
    {
        "name": "Kothrud to Bandra Taxi Service",
        "description": "Travel from Kothrud to Bandra with ease. Our professional taxi services ensure you travel comfortably in a clean and well-maintained vehicle."
    },
    {
        "name": "Kothrud to Mumbai Darshan Cab",
        "description": "Explore the landmarks of Mumbai with our Mumbai Darshan Cab service from Kothrud. We offer a personalized tour to all major attractions in Mumbai."
    },
    {
        "name": "Pune to Mumbai Taxi",
        "description": "For a safe and reliable ride from Pune to Mumbai, Vedant Travels offers top-notch taxi services. Choose from our fleet of well-maintained cars, including Ertiga and Innova."
    },
    {
        "name": "Pune to Mumbai Airport Cab",
        "description": "Book a taxi from Pune to Mumbai Airport with Vedant Travels. We offer timely airport transfers with comfortable vehicles, including Innova and Ertiga."
    },
    {
        "name": "Pune to Mumbai Ertiga Cab",
        "description": "Travel in style and comfort from Pune to Mumbai in an Ertiga. Ideal for families or groups, the Ertiga provides ample space and a smooth journey."
    },
    {
        "name": "Pune to Mumbai Innova Cab",
        "description": "Choose the Innova for your trip from Pune to Mumbai. Vedant Travels offers comfortable and spacious Innova Cabs for a luxurious ride."
    },
    {
        "name": "Kothrud to Mumbai Cab Service",
        "description": "Looking for a reliable and affordable cab service from Kothrud to Mumbai? Vedant Travels provides timely services with professional drivers."
    },
    {
        "name": "Kothrud to Mumbai Innova Cab Service",
        "description": "For a comfortable and luxurious ride from Kothrud to Mumbai, book an Innova with Vedant Travels. Enjoy a smooth journey with our experienced drivers."
    },
    {
        "name": "Kothrud to Dadar Cab Service",
        "description": "Book a Dadar cab from Kothrud with Vedant Travels. We provide quick, affordable, and comfortable transportation, ensuring you have a pleasant journey."
    },
    {
        "name": "Kothrud to Andheri Cab Service",
        "description": "Whether you're traveling from Kothrud to Andheri for business or leisure, Vedant Travels offers convenient, comfortable, and budget-friendly taxi services."
    },
    {
        "name": "Innova Crysta on Rent in Kothrud Pune",
        "description": "Rent a Toyota Innova Crysta from Kothrud Pune for your trip. The Innova Crysta offers the perfect combination of space, comfort, and luxury for any journey."
    },
    {
        "name": "Toyota Innova Crysta Car Hire in Pune",
        "description": "Book a Toyota Innova Crysta with Vedant Travels for your next trip from Kothrud. With luxurious seating and premium features, it’s the best choice for long-distance travel."
    },
    {
        "name": "Pune Mumbai Vedant Travels",
        "description": "At Vedant Travels, we offer reliable, comfortable, and affordable taxi services for your Pune to Mumbai trips, ensuring a hassle-free experience from start to finish."
    },
    {
        "name": "Contact Information",
        "description": "For bookings and inquiries, contact Vedant Travels at +91 8767459909. We provide top-quality taxi services for all your travel needs from Kothrud to Mumbai and beyond."
    }
],


"tableData": [
    ["kothrud to mumbai airport cab", "kothrud to mumbai international airport cab"],
    ["kothrud to mumbai one way cab", "kothrud to mumbai drop taxi"],
    ["kothrud to dadar taxi service", "kothrud to bandra taxi service"],
    ["kothrud to mumbai darshan cab", "pune to mumbai taxi"],
    ["pune to mumbai airport cab", "pune to mumbai ertiga cab"],
    ["Pune to Mumbai Innova Cab", "kothrud to mumbai cab service"],
    ["kothrud to mumbai innova cab service", "kothrud to dadar cab service"],
    ["kothrud to andheri cab service", "innova crysta on rent in kothrud pune"],
    ["Toyota Innova Crysta Car Hire in Pune", "Pune Mumbai Vedant Travels"],
    ["Cab service in pune", "Pune to Mumbai airport cab"]
],
"whychoose": [
    {
        "WhyChooseheading": "Reliable and On-Time Service",
        "WhyChoosedescription": "At Vedant Travels, we understand the value of time. Whether you're traveling for business or leisure, our drivers ensure timely pickups and drop-offs for your journey from Kothrud to Mumbai, making your ride smooth and on schedule."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "We offer a variety of well-maintained, spacious vehicles equipped with air conditioning and comfortable seating. Our cars are designed for a relaxed and enjoyable ride, ensuring you travel in comfort during your trip from Kothrud to Mumbai."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are highly skilled and experienced in long-distance travel. They are familiar with the best routes and traffic conditions to ensure a safe, smooth, and efficient journey from Kothrud to Mumbai."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Vedant Travels offers competitive and transparent pricing with no hidden charges. The fare is clearly communicated at the time of booking, ensuring you know exactly what to expect, without any surprises."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Safety is our priority. All our vehicles are equipped with modern safety features, such as airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols, providing you with a secure and comfortable travel experience."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Vedant Travels is available 24/7, ensuring that no matter the time, you can book a cab for your trip from Kothrud to Mumbai. Our customer service team is always available to assist you at any hour."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking your cab from Kothrud to Mumbai is quick and easy. You can book through our website or mobile app, or reach out to our customer service team for personalized assistance in booking your cab."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Whether you’re traveling for business, leisure, or any special occasion, we offer customized travel packages tailored to your needs. We can adjust the journey based on your preferences to make your trip even more comfortable and enjoyable."
    }
]




    








    }


    const faqData = [
        {
            id: 1,
            question: 'How can I book a Kothrud to Mumbai cab with Vedant Travels?',
            answer: 'You can book a cab easily through our website or mobile app. Alternatively, you can contact our customer service team for assistance in booking your ride.',
        },
        {
            id: 2,
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, our drivers are well-trained and experienced in handling long-distance routes, including the journey from Kothrud to Mumbai. They ensure your ride is safe, smooth, and comfortable.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for Kothrud to Mumbai travel?',
            answer: 'We offer a variety of vehicles, including sedans, SUVs, and luxury cars. All our vehicles are spacious, clean, and well-maintained to ensure a comfortable ride.',
        },
        {
            id: 4,
            question: 'How do I pay for my Kothrud to Mumbai cab rental?',
            answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payments via our app, making it easy and convenient to pay for your journey.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab from Kothrud to Mumbai?',
            answer: 'Yes, you can book a round-trip cab. Just provide the return details when booking, and we’ll handle everything for you.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges for waiting time or detours will be communicated to you upfront during the booking process, ensuring full transparency in our pricing.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing in Mumbai after my drop-off?',
            answer: 'Yes, we offer sightseeing services in Mumbai. You can explore iconic landmarks like the Gateway of India, Marine Drive, and more, with a trusted driver.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a Kothrud to Mumbai cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have additional luggage or specific requirements, please inform us during booking, and we will accommodate your needs.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel between Kothrud and Mumbai?',
            answer: 'Yes, we provide corporate travel services for business meetings, conferences, airport transfers, and more. Get in touch with us for customized corporate packages.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for my Kothrud to Mumbai journey?',
            answer: 'Vedant Travels offers reliable, safe, and affordable services with professional drivers, clean and spacious vehicles, and a customer-centric approach. We ensure a smooth and hassle-free journey from Kothrud to Mumbai.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Sandeep Joshi",
            title: "Customer",
            quote: "I traveled from Kothrud to Mumbai with Vedant Travels, and the experience was fantastic. The vehicle was clean, the driver was punctual, and the entire journey was smooth and stress-free. Highly recommended!",
            rating: 5,
        },
        {
            name: "Mrs. Manisha Sharma",
            title: "Customer",
            quote: "We used Vedant Travels for our family trip from Kothrud to Mumbai. The booking process was simple, the car was spacious and comfortable, and the driver was friendly and professional. Will definitely use them again!",
            rating: 5,
        },
    ];
    










    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    
   
      const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kothrud to Mumbai Cab | Vedant Travels",
  "image": "https://www.vedanttravels.in/images/kothrud-to-mumbai-cab.jpg",
  "description": "Book your Kothrud to Mumbai taxi with Vedant Travels. We offer one-way trips, airport transfers, and round trips with luxury vehicles like Innova Crysta, Ertiga, and Sedan. Get affordable fares, clean cabs, and experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "reviewCount": "4299",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1399",
    "availability": "https://schema.org/InStock",
    "url": "https://www.vedanttravels.in/kothrud-to-mumbai-cab",
    "validFrom": "2025-08-01"
  },
  "areaServed": {
    "@type": "Place",
    "name": ["Kothrud", "Pune", "Mumbai", "Mumbai Airport", "Andheri", "Bandra", "Dadar"]
  }
};




    return (
        <div>

<Helmet>
  <title>Kothrud to Mumbai Cab | Vedant Travels</title>
  <meta
    name="description"
    content="Book your Kothrud to Mumbai cab with Vedant Travels. Get one-way, round-trip, or airport transfer in Innova Crysta, Ertiga, or Sedan. Clean cars, professional drivers, and low fares guaranteed."
  />
  <meta
    name="keywords"
    content="Kothrud to Mumbai Cab, Kothrud to Mumbai Airport Taxi, Kothrud to Andheri Drop Cab, Kothrud to Bandra Cab, Innova Crysta from Kothrud to Mumbai, Ertiga Cab Kothrud to Mumbai, One Way Cab Kothrud to Mumbai, Vedant Travels Cab Booking Kothrud"
  />
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://www.vedanttravels.in/kothrud-to-mumbai-cab" />
  <script type="application/ld+json">{JSON.stringify(jsonData)}</script>
</Helmet>

            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/16.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Kothrudtomumbaicab;